import { useEffect, useRef, type ReactNode } from 'react';
import { useGT } from 'gt-react';
import { TaskReviewBody } from 'src/pages/authenticated/tasks/$taskId/TaskReviewBody';

export function InspectedTaskRail({
  taskId,
  trailing,
}: {
  taskId: string;
  trailing?: ReactNode;
}) {
  const gt = useGT();
  const railRef = useRef<HTMLDivElement>(null);

  // The rail mounts under a row that may sit at the bottom of the viewport;
  // bring the review into view without jumping when it already fits.
  useEffect(() => {
    railRef.current?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }, [taskId]);

  return (
    <div
      ref={railRef}
      className="rounded-b-md border-l-2 border-l-border bg-muted/50"
      role="region"
      aria-label={gt('Details for the selected task', {
        context:
          'agent monitor review rail attached under the selected queue row',
      })}
    >
      <div className="min-w-0 py-2 pl-3 pr-2">
        <TaskReviewBody
          key={taskId}
          taskId={taskId}
          layout="rail"
          trailing={trailing}
        />
      </div>
    </div>
  );
}
